import { render, staticRenderFns } from "./UserDataContainer.vue?vue&type=template&id=3f8c9166&scoped=true&"
import script from "./UserDataContainer.vue?vue&type=script&lang=js&"
export * from "./UserDataContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserDataContainer.vue?vue&type=style&index=0&id=3f8c9166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8c9166",
  null
  
)

export default component.exports